import { useContext } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Grid, Typography, Button, Paper, SvgIcon, Container, CircularProgress } from "@mui/material";
import { UserDataContext } from "../app/App";
import { ReactComponent as GardlistLogo } from "../components/img/gardlist-logo.svg";
import packageJson from "../../package.json";

const ActionCard = (props) => {
    const { actionKey, privilege, route, color } = props;
    const { t, ready } = useTranslation();

    if (!ready) {
        return (
            <Container>
                <CircularProgress />
            </Container>
        );
    }

    return (
        <Paper
            sx={{
                p: 1,
                display: "flex",
                justifyContent: "center",
                backgroundColor: color,
                alignItems: "center",
                aspectRatio: "1 / 1",
                width: "100%",
            }}
            elevation={3}
        >
            <Button
                sx={{ width: "100%", height: "100%", textTransform: "none" }}
                component={Link}
                to={route}
            >
                <Typography align="center" sx={{ color: "#fff" }}>
                    {t(actionKey)}
                </Typography>
            </Button>
        </Paper>
    );
};

const ActionsGrid = () => {
    const { user } = useContext(UserDataContext);
    const actionsGrid = [
        { actionKey: "Timeclock", privilege: "Stimpilklukka", route: "/timeclock/", color: "rgb(141, 198, 63)" },
        { actionKey: "Gardening", privilege: "Garðyrkja", route: "/Gardening", color: "rgb(225 190 16)" },
        { actionKey: "Mowing", privilege: "Sláttur", route: "/Mowing", color: "rgb(75 113 23)" },
        { actionKey: "Winterwork", privilege: "Vetrarverk", route: "/winterwork", color: "rgb(55,96,178)" },
        { actionKey: "Inspection", privilege: "Eftirlit", route: "/Inspection", color: "rgb(86 179 169)" },
        { actionKey: "ReportBroken", privilege: "Bilanaskráning", route: "/report/broken", color: "rgb(173 0 0)" },
        { actionKey: "Workshop", privilege: "Verkstæði", route: "/workshop", color: "rgb(227 149 2)" },
        { actionKey: "Warehouse", privilege: "Lager", route: "/warehouse", color: "rgb(249 98 125)" },
        { actionKey: "ReportIncident", privilege: "Garðyrkja", route: "/report/incident", color: "rgb(16 185 129)" },
    ];

    const allowedActions = actionsGrid.filter((action) =>
        user.crmPrivileges.some((privilege) => privilege.name === action.privilege)
    );

    return (
        <Container sx={{ p: 2 }}>
            <Grid container spacing={1}>
                {/* Logo */}
                <Grid item xs={6} sm={4} md={3} lg={2}>
                    <Paper
                        sx={{
                            position: "relative",
                            aspectRatio: "1 / 1",
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                        elevation={3}
                    >
                        <SvgIcon component={GardlistLogo} inheritViewBox sx={{ width: "100%", height: "100%" }} />
                        <Typography variant="caption" sx={{ bottom: "5%", position: "absolute" }}>
                            ver. {packageJson.version}
                        </Typography>
                    </Paper>
                </Grid>
                {allowedActions.map((action) => (
                    <Grid key={action.actionKey} item xs={6} sm={4} md={3} lg={2}>
                        <ActionCard {...action} />
                    </Grid>
                ))}
            </Grid>
        </Container>
    );
};

export default ActionsGrid;
